import { render, staticRenderFns } from "./externalPelayanan.vue?vue&type=template&id=06bbf90a"
import script from "./externalPelayanan.vue?vue&type=script&lang=js"
export * from "./externalPelayanan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06bbf90a')) {
      api.createRecord('06bbf90a', component.options)
    } else {
      api.reload('06bbf90a', component.options)
    }
    module.hot.accept("./externalPelayanan.vue?vue&type=template&id=06bbf90a", function () {
      api.rerender('06bbf90a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/external/pelayanan/externalPelayanan.vue"
export default component.exports